import CheckBoxFilter from './CheckBoxFilter'

export default CheckBoxFilter



// WEBPACK FOOTER //
// ./src/modules/Filters/CheckBoxFilter/index.js